/**
 * Generated cruise import trip titles — mirrors iOS ImportCruiseItineraryView refresh.
 * Uses the same medium-date formatter as defaultTripName / formatEmbarkDateMedium.
 */

import { formatEmbarkDateMedium } from '../services/cruiseItinerariesApi';

/** `"Ship — mediumDate"` using traveler start (includes Pre-Cruise). */
export function generatedCruiseTripName(shipName: string, travelerStartYmd: string): string {
  const ship = shipName.trim() || 'Cruise';
  return `${ship} — ${formatEmbarkDateMedium(travelerStartYmd)}`;
}

/**
 * Refresh generated title when Pre dates change unless the user edited the title.
 * Mirrors iOS refreshGeneratedTripNameIfNeeded.
 */
export function nextCruiseTripNameAfterPreDateChange(options: {
  currentName: string;
  shipName: string;
  embarkArrivalYmd: string | null;
  hasUserEditedTripTitle: boolean;
}): string {
  if (options.hasUserEditedTripTitle) return options.currentName;
  if (!options.embarkArrivalYmd) return options.currentName;
  const ship = options.shipName.trim();
  if (!ship) return options.currentName;
  return generatedCruiseTripName(ship, options.embarkArrivalYmd);
}
